import { PropsWithChildren } from 'react';

import usePolicy from '@/hooks/usePolicy.ts';
import VerificationFailed from '@/components/Verification/VerificationFailed.tsx';

interface GuardProps extends PropsWithChildren {
  component: 'search' | 'messenger' | 'likes';
}

const Guard = ({ children, component }: GuardProps) => {
  const { isActive, isFailedVerification } = usePolicy();

  switch (component) {
    case 'search':
    case 'messenger':
    case 'likes':
      if (isActive) return children;
      if (isFailedVerification) return <VerificationFailed bottom="90px" />;
      return children;
    default:
      return children;
  }
};

export default Guard;
